import React from 'react';
import PropTypes from 'prop-types';
import { Link, Text } from 'components/atoms';

export default function Crumb({ children, label, href, isLast }) {
	return React.createElement(
		!isLast ? Link : Text,
		{
			href,
		},
		children || label,
	);
}

Crumb.propTypes = {
	children: PropTypes.node,
	label: PropTypes.string.isRequired,
	href: PropTypes.string,
	isLast: PropTypes.bool,
};
